import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import SupplierSelector from "./SupplierSelector";
import WarehouseSelector from "./WarehouseSelector";
import useAdminInventoryStore from "../../store/useAdminInventoryStore";
import { useExportInventory } from "../../features/adminInventory/useExportInventory";
import Button from "../Button";

const SearchFilterToolbar = () => {
  const filters = useAdminInventoryStore((state) => state.filters);
  const setSearch = useAdminInventoryStore((state) => state.setSearch);
  const setFilterField = useAdminInventoryStore((state) => state.setFilterField);
  const resetFilters = useAdminInventoryStore((state) => state.resetFilters);

  const [searchValue, setSearchValue] = useState(filters.search || "");
  const { mutate: exportInventory, isPending: isExporting } = useExportInventory();

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue, setSearch]);

  const toGregorianISO = (date) => {
    if (!date) return "";
    try {
      return date.toDate().toISOString();
    } catch {
      return "";
    }
  };

  const handleDateChange = (field, dateValue) => {
    const isoValue = toGregorianISO(dateValue);

    if (!isoValue) {
      setFilterField(field, "");
      return;
    }

    setFilterField(field, isoValue);
  };


  return (
    <div className="min-w-0 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 2xl:grid-cols-4">
        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            جستجو
          </label>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="نام، کد، برند یا دسته کالا"
            className="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none transition focus:border-blue-500"
          />
        </div>

        <SupplierSelector />
        <WarehouseSelector />

        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            وضعیت کالا
          </label>
          <select
            value={filters.is_active}
            onChange={(e) => setFilterField("is_active", e.target.value)}
            className="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none transition focus:border-blue-500"
          >
            <option value="">همه</option>
            <option value="true">فعال</option>
            <option value="false">غیرفعال</option>
          </select>
        </div>

        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            وضعیت موجودی
          </label>
          <select
            value={filters.inventory_is_active}
            onChange={(e) =>
              setFilterField("inventory_is_active", e.target.value)
            }
            className="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none transition focus:border-blue-500"
          >
            <option value="">همه</option>
            <option value="true">فعال</option>
            <option value="false">غیرفعال</option>
          </select>
        </div>

        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            از تاریخ ساخت
          </label>
          <DatePicker
            value={filters.date_from}
            onChange={(value) => handleDateChange("date_from", value)}
            calendar={persian}
            locale={persian_fa}
            placeholder="روز/ماه/سال"
            inputClass="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none focus:border-blue-500"
            containerClassName="w-full"
          />
        </div>

        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            تا تاریخ ساخت
          </label>
          <DatePicker
            value={filters.date_to}
            onChange={(value) => handleDateChange("date_to", value)}
            calendar={persian}
            locale={persian_fa}
            placeholder="روز/ماه/سال"
            inputClass="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none focus:border-blue-500"
            containerClassName="w-full"
          />
        </div>

        <div className="min-w-0">
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            مرتب‌سازی
          </label>
          <select
            value={filters.ordering}
            onChange={(e) => setFilterField("ordering", e.target.value)}
            className="h-11 w-full rounded-lg border border-gray-300 px-3 text-sm outline-none transition focus:border-blue-500"
          >
            <option value="newest">جدیدترین</option>
            <option value="oldest">قدیمی‌ترین</option>
            <option value="newest_review">جدیدترین تایید</option>
            <option value="oldest_review">قدیمی‌ترین تایید</option>
            <option value="highest_stock">بیشترین موجودی</option>
            <option value="lowest_stock">کمترین موجودی</option>
            <option value="highest_price">بیشترین قیمت</option>
            <option value="lowest_price">کمترین قیمت</option>
          </select>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-3">
        <Button
          variant={'primary'}
          onClick={() => exportInventory()}
          disabled={isExporting}
          children={'خروجی اکسل'}
          />
        <Button
          variant={'secondary'}
          onClick={() => {
            resetFilters();
            setSearchValue("");
          }}
          children={'حذف فیلتر'}
          />
      </div>
    </div>
  );
};

export default SearchFilterToolbar;
